import { Box } from "@material-ui/core";
import { TextField } from "@mui/material";
import React, { Fragment, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { changePassword } from "../../../Utils/actions";
import { useDispatch } from "react-redux";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const ChangePass = () => {
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [error, setError] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    passwordMatch: "",
  });

  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });

    setError({
      ...error,
      [name]: "",
      passwordMatch: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let hasError = false;
    const newError = {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      passwordMatch: "",
    };

    if (!form.oldPassword) {
      newError.oldPassword = "Old password is required";
      hasError = true;
    }

    if (!form.newPassword) {
      newError.newPassword = "New password is required";
      hasError = true;
    }

    if (!form.confirmPassword) {
      newError.confirmPassword = "Confirm password is required";
      hasError = true;
    }

    if (form.newPassword !== form.confirmPassword) {
      newError.passwordMatch = "New and Confirm passwords do not match";
      hasError = true;
    }

    if (form.oldPassword === form.newPassword) {
      newError.newPassword = "Old and New passwords cannot be the same";
      hasError = true;
    }

    setError({ ...newError });

    if (hasError) {
      return;
    }
    const userName = localStorage.getItem("username");
    console.log("userName-->", userName);
    console.log("Form submitted:", form);
    const data = {
      username: userName,
      oldPassword: form.oldPassword,
      password: form.confirmPassword,
    };
    console.log("data==>", data);
    // const data = {
    dispatch(changePassword(data));
    // }
  };

  return (
    // <div style={{ width: "100%" }}>
    //   <div className="col-md-12" style={{ height: "86vh", padding: "15px" }}>
    <Fragment>
      {/* <Card
            className="w-100 h-100 mx-auto user-roles shadow-none h-100 border-0 password-page"
            style={{
              display: "flex",
              flexDirection: "column",
              paddingTop: "5px",
              // alignItems: "center",
              // justifyContent: "center",
              //   marginTop: "50px",
            }}
          > */}
      <Card
        className={"shadow-none w-100 manage-pass-card"}
        style={{
          backgroundColor: "#333333",
          padding: "15px",
          overflow: "auto",
          height: "89vh",
          border: "none",
          borderRadius: "unset",
        }}
      >
        <Card.Body
          className={"managepass_content"}
          style={{
            borderRadius: "0.25rem",
            background: "#242424",
            overflow: "auto",
            padding: "10px 25px",
          }}
        >
          {/* <Card.Body> */}
          <Box
            component="form"
            className="addUserBox"
            onSubmit={handleSubmit}
            noValidate
            autoComplete="off"
          >
            <div className="manage_pass">
              <div className="col-md-4">
                <TextField
                  className="input-field"
                  style={{ marginTop: "10px" }}
                  inputMode="oldPassword"
                  type={showPassword.oldPassword ? "text" : "password"}
                  name="oldPassword"
                  label="Old password"
                  value={form.oldPassword}
                  required
                  onChange={handleChange}
                  error={!!error.oldPassword}
                  helperText={error.oldPassword}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            togglePasswordVisibility("oldPassword")
                          }
                        >
                          {showPassword.oldPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="col-md-4">
                <TextField
                  className="input-field"
                  style={{ marginTop: "10px" }}
                  inputMode="newPassword"
                  type={showPassword.newPassword ? "text" : "password"}
                  name="newPassword"
                  label="New Password"
                  value={form.newPassword}
                  required
                  onChange={handleChange}
                  error={!!error.newPassword}
                  helperText={error.newPassword}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            togglePasswordVisibility("newPassword")
                          }
                        >
                          {showPassword.newPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="col-md-4">
                <TextField
                  className="input-field"
                  type={showPassword.confirmPassword ? "text" : "password"}
                  style={{ marginTop: "10px" }}
                  name="confirmPassword"
                  label="Confirm Password"
                  value={form.confirmPassword}
                  required
                  onChange={handleChange}
                  error={!!error.confirmPassword || !!error.passwordMatch}
                  helperText={error.confirmPassword || error.passwordMatch}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            togglePasswordVisibility("confirmPassword")
                          }
                        >
                          {showPassword.confirmPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="col-md-4">
                <Button
                  type="submit"
                  style={{
                    background: 'linear-gradient(135deg, rgb(79, 79, 79), rgb(30, 30, 30))',
                  border: '1px solid rgb(58, 58, 58)',
                    color: "#fff",
                    marginTop: "10px",
                    padding: "8px 25px",
                    // marginLeft: "15px",
                    // padding: "5px 25px",
                  }}
                >
                  Save
                </Button>
              </div>
            </div>
          </Box>
        </Card.Body>
      </Card>
    </Fragment>
    //   </div>
    // </div>
  );
};

export default ChangePass;
